<!-- OrderIndex.vue -->
<template>
  <SubNavCardVue :buttons="buttons">
    <router-view></router-view>
  </SubNavCardVue>
</template>

<script>
import SubNavCardVue from '@/components/cards/SubNavCard.vue'

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        // Commandes clients
        {
          label: 'Commandes Clients',
          icon: 'bi bi-list-ul',
          route: 'orders-index'
        },
        // {
        //   label: 'Nouvelle commande client',
        //   icon: 'bi bi-plus-square',
        //   route: 'orders-create'
        // },
        // {
        //   label: 'Ajouter articles client',
        //   icon: 'bi bi-bag-plus',
        //   route: 'orders-items-create'
        // },

        // Commandes fournisseurs
        {
          label: 'Commandes Fournisseurs',
          icon: 'bi bi-list-check',
          route: 'orders-suppliers-index'
        },
        // {
        //   label: 'Nouvelle commande fournisseur',
        //   icon: 'bi bi-plus-circle',
        //   route: 'orders-suppliers-create'
        // },
        // {
        //   label: 'Ajouter articles fournisseur',
        //   icon: 'bi bi-basket',
        //   route: 'orders-suppliers-items-create'
        // },
      ]
    }
  }
}
</script>
